import { useFieldContext } from '~/util/hooks/useFormContext';
import { FieldLabelWithError } from './FieldLabelWithError';
import type { FieldWithErrorProps } from './FieldLabelWithError';
import { cn } from '~/util';
import { useDisableFormContext } from '../DisableContext';
import { Checkbox } from '~/primitives/checkbox';
import { useEffect } from 'react';

export function CheckboxField({
    switchLabel,
    ...labelProps
}: FieldWithErrorProps & { switchLabel?: string }) {
    const field = useFieldContext<boolean>();
    const disabled = useDisableFormContext();

    useEffect(() => {
        if (field.state.value == null) {
            field.handleChange(false);
        }
    }, [field, field.state.value]);

    return (
        <FieldLabelWithError<boolean> {...labelProps}>
            <div className="flex gap-2 py-2 items-center">
                <Checkbox
                    disabled={disabled}
                    className={cn(disabled && 'opacity-50 cursor-not-allowed')}
                    id={field.name}
                    checked={field.state.value === true}
                    onCheckedChange={(checked) => {
                        field.handleChange(checked == true);
                    }}
                />
                {switchLabel && (
                    <label htmlFor={field.name}>{switchLabel}</label>
                )}
            </div>
        </FieldLabelWithError>
    );
}
